import React from 'react';
import './month-totals.less';
import { Month } from '../../../domain/util/date';
import useLegacyMoneyFormatter from '../../common/hooks/useLegacyMoneyFormatter';
import useMonthTotalBudgeted from '../../store/budget/hooks/useMonthTotalBudgeted';
import useMonthTotalOutflows from '../../store/budget/hooks/useMonthTotalOutflows';
import useMonthTotalBalance from '../../store/budget/hooks/useMonthTotalBalance';

type Props = {
	month: Month
}

const MonthTotals = ({ month }: Props) => {
	const budgeted = useMonthTotalBudgeted(month);
	const outflows = useMonthTotalOutflows(month);
	const balance = useMonthTotalBalance(month);
	const formatCurrencyForDisplay = useLegacyMoneyFormatter();

	return (
		<div className={'month-totals'}>
			<div className={'month-totals__cell'}>
				<div className={'month-totals__column-label'}>{'Budgeted'}</div>
				<span className={'month-totals__value'}>
					{formatCurrencyForDisplay(budgeted)}
				</span>
			</div>
			<div className={'month-totals__cell'}>
				<div className={'month-totals__column-label'}>{'Outflows'}</div>
				<span className={'month-totals__value'}>
					{formatCurrencyForDisplay(outflows)}
				</span>
			</div>
			<div className={'month-totals__cell'}>
				<div className={'month-totals__column-label'}>{'Balance'}</div>
				<span className={'month-totals__value'}>
					{formatCurrencyForDisplay(balance)}
				</span>
			</div>
		</div>
	);
};

export default MonthTotals;
